<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="TOC"><a href="#/Acknowledgments">Acknowledgements</a></p>
<p class="TOC"><a href="#/Introduction">Introduction</a></p>
<p class="TOC1"><a href="#/Chapter01">1. The Kill Shot</a></p>
<p class="TOC"><span href="#/Chapter02" title="Link target outside of Sample">2. The Loop 360 Deal</span></p>
<p class="TOC"><span href="#/Chapter03" title="Link target outside of Sample">3. The Hunt</span></p>
<p class="TOC"><span href="#/Chapter04" title="Link target outside of Sample">4. The Break</span></p>
<p class="TOC"><span href="#/Chapter05" title="Link target outside of Sample">5. From State to Federal Court</span></p>
<p class="TOC"><span href="#/Chapter06" title="Link target outside of Sample">6. The Lawyers and the Judge</span></p>
<p class="TOC"><span href="#/Chapter07" title="Link target outside of Sample">7. The Trial, Part One</span></p>
<p class="TOC"><span href="#/Chapter08" title="Link target outside of Sample">8. The Trial, Part Two</span></p>
<p class="TOC"><span href="#/Chapter09" title="Link target outside of Sample">9. Sentencing and Appeal</span></p>
<p class="TOC"><span href="#/Chapter10" title="Link target outside of Sample">10. The Aftermath</span></p>
<p class="TOC1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="TOC"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?638f2322